import PropTypes from 'prop-types';
import cx from 'classnames';

import isNotEmptyReactElementContent from 'core/utils/content';

import H3 from '../H3';
import withBreakpoint from 'core/hocs/withBreakpoint';

import styles from './index.styl';

/**
 * @author Evgeny Shiryaev <e.shiryaev@rambler-co.ru>
 */
function Mjolnir(props) {
  const {
    title,
    content,
    card: Card,
    heroCard: HeroCard,
    headerComponent: Header,
    cardsReplacement,
    cardsContainerPadding,
    interitemSpacing,
    isMobile,
    dataQa,
  } = props;

  if (!content?.length) return null;

  const replacements = cardsReplacement || {};
  const [heroCardContent, ...smallCardContent] = content;

  return (
    <div className='mjolnir' {...dataQa && { 'data-qa': dataQa }}>
      <style jsx>{`
        .header
          margin-bottom ${interitemSpacing}px

        .smallCards
          display ${isMobile ? 'block' : 'flex'}
          margin ${interitemSpacing}px -${interitemSpacing / 2}px 0
          padding ${cardsContainerPadding}px

          :global(.mobile) &
            margin ${interitemSpacing}px 0 0

        .item
          padding 0 ${interitemSpacing / 2}px

          :global(.mobile) &
            padding 0

          & + &
            margin-top ${isMobile ? `${interitemSpacing}px` : 0 }
      `}</style>
      {isNotEmptyReactElementContent(title) && (
        <div className='header' {...dataQa && { 'data-qa': dataQa + '-title' }}>
          <Header>{title}</Header>
        </div>
      )}
      <HeroCard content={heroCardContent} position={0} />
      <div className='smallCards' {...dataQa && { 'data-qa': dataQa + '-cards' }}>
        {smallCardContent.map((topic, i) => {
          const cardProps = {
            position: i + 1,
            content: topic,
          };
          /**
           * i + 1 потому что считаем, что 1 карточка - это HeroCard
           */
          const Replacement = replacements[i + 1];

          const card = <Card {...cardProps} />;

          const item = Replacement
            ? <Replacement {...cardProps} card={card} />
            : card;

          return (
            <div key={topic.id} className={cx('item', styles.item)}>
              {item}
            </div>
          );
        })}
      </div>
    </div>
  );
}

Mjolnir.propTypes = {
  /**
   * Компонент для маленьких карточек
   */
  card: PropTypes.func.isRequired,

  /**
   * Данные о топиках.
   */
  content: PropTypes.array,

  /**
   * Компонент, в который будет завёрнут заголовок блока.
   */
  headerComponent: PropTypes.func,

  /**
   * Компонент главной карточки
   */
  heroCard: PropTypes.func.isRequired,

  /**
   * Заголовок блока.
   */
  title: PropTypes.node,

  /**
   * Расстояние между карточками (горизонтальное + вертикальное).
   */
  interitemSpacing: PropTypes.number.isRequired,

  /**
   * Дополнительный паддинг для контейнера маленьких карточек
   */
  cardsContainerPadding: PropTypes.number,

  /**
   * Справочник замен карточек на другие компоненты.
   *
   * В качестве ключа должен выступать индекс карточки которую нужно заменить,
   * а в качестве значения компонент на который будет заменена карточка.
   *
   * Элемент отрисованной карточки с данными будет передан в новый компонент
   * в качестве пропса `card`.
   */
  cardsReplacement: PropTypes.objectOf(PropTypes.func.isRequired),
  /** @ignore */
  isMobile: PropTypes.bool,
  /** @ignore */
  dataQa: PropTypes.string,
};

Mjolnir.defaultProps = {
  interitemSpacing: 0,
  cardsContainerPadding: 0,
  headerComponent: H3,
};

const MjolnirWithHOCs = withBreakpoint(Mjolnir);

MjolnirWithHOCs.displayName = 'Mjolnir';

export { Mjolnir as StorybookComponent };
export default MjolnirWithHOCs;
